import React from "react";
import "./Button.scss";
import { DownloadIcon } from "../icons";

const ButtonWithTextIcon = ({
  children, // Content to be displayed inside the button
  variant = "primary", // Button style variant (primary, secondary, etc.)
  size = "md", // Size of the button (sm, md, lg)
  disabled = false, // Whether the button is disabled
  icon: Icon = DownloadIcon, // Icon component to be displayed
  className = "", // Additional CSS classes
  ...props // Additional props to be spread on the button
}) => {
  /* === Class Name Generation === */
  const prenetClasses = `borderWrapper button-parent ${className} ${disabled ? "disabled" : ""}`;
  const classes = `button withTextIcon borderInner ${variant} ${size} ${
    disabled ? "disabled" : ""
  }`;
  /* === End Class Name Generation === */

  return (
    <div className={prenetClasses}>
      <button className={classes} disabled={disabled} {...props}>
        <Icon size={size} className="" />
        {children}
      </button>
    </div>
  );
};

export default ButtonWithTextIcon;
